export default "__VITE_ASSET__C0V5NQvF__"